import React, { useState, useEffect } from 'react';
import { Text } from '@mantine/core';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import * as duration from 'dayjs/plugin/duration';

dayjs.extend(duration);

const TimerEvent = () => {
  const navigate = useNavigate();

  const [seconds, setSeconds] = useState(130);

  useEffect(() => {
    const interval = setInterval(() => {
      setSeconds((value) => {
        if (value > 0) {
          return value - 1;
        }
        return value;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (seconds <= 0) {
      navigate('/');
    }
  }, [navigate, seconds]);

  return (
    <div>
      {seconds <= 120 ? (
        <Text size="sm">Time Left {dayjs.duration(seconds * 1000).format('mm:ss')} </Text>
      ) : null}
    </div>
  );
};
export default TimerEvent;
